var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RequestButton',{attrs:{"displayIcon":"","text":_vm.text,"loading":_vm.loading,"error":_vm.error,"icon":_vm.icon},on:{"click":function($event){return _vm.sortOrUnsort()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }